// extracted by mini-css-extract-plugin
export default {"scrollToTop":"style_scrollToTop__-8QLf"};